import styled from 'styled-components'
import { Table } from 'antd'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'

export const StyledTableSqare = styled(Table)`
  padding: ${props => (props.padding ? props.padding : '0px')};
  width: ${props => (props.width ? props.width : '')};

  .ant-table-ping-right .ant-table-content,
  .ant-table-ping-left .ant-table-content {
    overflow: auto hidden !important;
  }
  .ant-table-content {
    overflow: revert !important;
  }
  .ant-table-thead {
    height: 60px;
  }

  td.last-ant-table-current-round {
    border-right: 3px solid rgba(50, 73, 215, 1) !important;
    border-left: 3px solid rgba(50, 73, 215, 1) !important;
  }

  th.last-ant-table-current-round {
    background-color: rgba(50, 73, 215, 1) !important;
    color: white;
  }
  .last-tr-class td.last-ant-table-current-round {
    border-bottom: 3px solid rgba(50, 73, 215, 1) !important;
  }

  tr:last-child td.last-ant-table-current-round {
    border-bottom: 3px solid rgba(50, 73, 215, 1) !important;
  }

  .ant-table-cell {
    border: 1px solid rgba(127, 127, 127, 0.25);
    padding: 10px;
  }

  border-top-left-radius: 0;
  border-top-right-radius: 0;

  border-top-radius: 0;
  border-top-left-radius: 0;
  border-top-right-radius: 0;

  .ant-table-container table > thead > tr:first-child th:first-child,
  .ant-table-container table > tbody > tr td:first-child {
    padding-left: 15px;
  }
  .ant-table-container table > thead > tr:first-child th:last-child,
  .ant-table-container table > tbody > tr td:last-child {
    padding-right: 25px;
  }
  .ant-table-cell ant-table-selection-column ant-table-cell-fix-left {
    background: #5970e3 !important;
  }
  .ant-table-thead > tr:first-child > th {
    background-color: #F0F0F1;
  }

  ${
    '' /* .ant-table-thead > tr > th {
    background-color: white;
  } */
  }
  .ant-table-column-title {
    width: 90%;
    z-index: 0;
  }
  .ant-table-cell.ant-table-cell-fix-left-last {
    z-index: 1;
  }

  tr {
    th {
      background: '#637487' !important;
      font-style: normal;
      font-weight: ${props => (props.fontWeight ? '600' : FONT.FW_500)};
      font-size: ${props => (props.fontSize ? '12px' : FONT.F_XS)};
      line-height: 1.125em;
      letter-spacing: 0.1em;
      text-transform: uppercase;
      color: ${COLORS.GREY_T_30};

      ::before {
        height: 0px;
      }
    }
  }
  .ant-table-pagination.ant-pagination {
    justify-content: center;
  }
  .ant-radio-inner {
    background-color: transparent;
  }
  ${
    '' /* .ant-checkbox-indeterminate .ant-checkbox-inner::after {
    background-color: transparent;
    ${'' 
  }
  } */
  }
  .ant-table-expanded-row td {
    padding: ${props =>
      props?.expandedRowPadding ? props?.expandedRowPadding : '0'} !important;
  }
`
